<template>
  <div>
    <LayoutContent>
      <SectionTitle :label="$t('label.convertToPoints')" />
      <v-card class="rounded-lg overflow-hidden" v-if="currentAgent">
        <div class="coin-conversion--container rounded-lg overflow-hidden elevation-3">
          <div class="d-flex flex-column justify-center pa-8 primary lighten-1 white--text">
            <h4 class="text-center text-h5 font-weight-bold">{{ $t('label.availableCashBalance') }}</h4>
            <p class="text-center text-h6 font-weight-medium">{{ currentAgent.currency }} {{ currentAgent.total_cashback }}</p>
          </div>
          <div class="pa-8">
            <p class="font-weight-bold text-subtitle-2">{{ $t('label.convertPoints') }}</p>
            <p class="font-weight-bold text-subtitle-2">{{ $t('label.getExtraPercentageMore', { percentage: currentAgent.agent_point_conversion_extra_percentage }) }}</p>
            <small class="text-caption">{{ $t('label.agentPointConversionRate', { currency: currentAgent.currency, rate: currentAgent.normal_point_conversion_rate }) }}</small>
            <v-text-field
              v-model="form.cash"
              :prefix="currentAgent.currency"
              :suffix="conversion"
              type="number"
              placeholder="0"
              hide-details
              single-line
              color="primary lighten-1"
              class="d-block mb-auto shrink primary--input text-h5"
            />
          </div>
          <div class="coin-options--wrapper pa-8">
            <v-btn
              v-for="amount in presetCashAmounts"
              depressed
              text
              outlined
              color="primary darken-1"
              class="coin-option font-weight-bold"
              :key="amount"
              @click="form.cash = amount"
              :disabled="amount > currentAgent.total_cashback"
            >
              {{ currentAgent.currency }} {{ amount }}
            </v-btn>
          </div>
        </div>
      </v-card>
      <v-dialog content-class="elevation-0" v-model="showConfirmDialog" max-width="500">
        <v-card class="">
          <v-card-text class="pa-8 rounded-lg">
            <p class="text-center font-weight-medium text-subtitle-1">
              {{
                $t('message.cashConversionConfirmationMessage', {
                  currency: currentAgent.currency,
                  cashAmount: form.cash,
                  point: form.cash * currentAgent.normal_point_conversion_rate * (1 + currentAgent.agent_point_conversion_extra_percentage / 100)
                })
              }}
            </p>
          </v-card-text>
          <v-card-actions class="flex justify-end">
            <v-btn color="primary" class="mr-4" outlined @click="showConfirmDialog = false">{{ $t('button.no') }}</v-btn>
            <v-btn color="primary" @click="convert">{{ $t('button.yes') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </LayoutContent>
    <bottom-bar>
      <v-container class="py-3 d-flex align-center justify-center"><app-button :label="$t('label.convertNow')" @click="showConfirmDialog = true" /></v-container>
    </bottom-bar>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import { mapState, mapActions } from 'vuex'
import { localeHelper } from '@/utils'

export default {
  name: 'ConvertPoint',
  components: { LayoutContent, SectionTitle },
  data: () => ({
    presetCashAmounts: [50, 100, 300, 500],
    form: {
      cash: 50
    },
    showConfirmDialog: false
  }),
  computed: {
    ...mapState('agent', ['currentAgent']),
    conversion() {
      return ` = ${this.form.cash * this.currentAgent.normal_point_conversion_rate * (1 + this.currentAgent.agent_point_conversion_extra_percentage / 100)} ${localeHelper.getMessage('label.points')}`
    }
  },
  methods: {
    ...mapActions('agent', ['convertPoint']),
    ...mapActions('auth', ['getProfile']),
    convert() {
      if (Number(this.form.cash) <= 0) {
        this.$toast.error(localeHelper.getMessage('error.invalidAmount'))
      } else {
        this.convertPoint({ cash: this.form.cash, coin: this.form.cash * this.currentAgent.normal_point_conversion_rate * (1 + this.currentAgent.agent_point_conversion_extra_percentage / 100) })
          .then((res) => {
            this.getProfile()
            this.$router.push({ name: this.$constants.ROUTE_NAME.AGENT_CONVERT_POINT_COMPLETE })
          })
          .catch((err) => this.$toast.error(err.error_message))
          .finally(() => (this.showConfirmDialog = false))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coin-conversion--container {
  display: grid;
  grid-template-columns: 1fr;
  @media only screen and (min-width: 1000px) {
    grid-template-columns: 2fr 3fr 3fr;
  }
}

.coin-options--wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.coin-option {
  border-color: var(--v-primary-lighten1) !important;
}
</style>
